import React from 'react';
import { faPencil, faCheck, faBan } from '@fortawesome/pro-regular-svg-icons';
import { Vehicle } from '@spike/vehicle-model';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import ThreeDotsDropdown from 'components/UI/V3/ThreeDotsDropdown/ThreeDotsDropdown';
import { ThreeDotsDropdownOption } from 'components/UI/V3/ThreeDotsDropdown/ThreeDotsDropdownOption';
import styles from './VehicleRow.module.scss';

interface VehicleRowProps {
    vehicle: Vehicle;
    isLast: boolean;
    isMobile: boolean;
    onEdit: (vehicle: Vehicle) => void;
    onActivate: (vehicle: Vehicle) => void;
    onDeactivate: (vehicle: Vehicle) => void;
}

const VehicleRow: React.FC<VehicleRowProps> = ({ vehicle, isLast, isMobile, onEdit, onActivate, onDeactivate }) => {
    // Use vehicle photo or fallback to placeholder
    const vehicleImage = vehicle.photos?.[0]?.url || '/images/transportation/van-empty.png';

    // Dropdown options
    const dropdownOptions: Array<ThreeDotsDropdownOption> = [
        {
            id: 'edit',
            label: 'Edit',
            icon: faPencil,
            onClick: () => onEdit(vehicle)
        },
        vehicle.active
            ? {
                  id: 'deactivate',
                  label: 'Deactivate',
                  icon: faBan,
                  onClick: () => onDeactivate(vehicle)
              }
            : {
                  id: 'activate',
                  label: 'Activate',
                  icon: faCheck,
                  onClick: () => onActivate(vehicle)
              }
    ];

    // Mobile view (2 columns: Vehicle + Actions)
    if (isMobile) {
        return (
            <TableRow>
                <TableCell className={styles.vehicleCell}>
                    <div className={styles.vehicleNameWrapper}>
                        <div className={styles.vehicleImageWrapper}>
                            <img
                                src={vehicleImage}
                                alt={vehicle.name}
                                className={styles.vehicleImage}
                            />
                        </div>
                        <span className={styles.vehicleName}>{vehicle.name}</span>
                    </div>
                </TableCell>
                <TableCell isActions>
                    <ThreeDotsDropdown
                        options={dropdownOptions}
                        direction={isLast ? 'up' : 'down'}
                    />
                </TableCell>
            </TableRow>
        );
    }

    // Desktop view (3 columns: Vehicle + Max Pets + Actions)
    return (
        <TableRow>
            <TableCell className={styles.vehicleCell}>
                <div className={styles.vehicleNameWrapper}>
                    <div className={styles.vehicleImageWrapper}>
                        <img
                            src={vehicleImage}
                            alt={vehicle.name}
                            className={styles.vehicleImage}
                        />
                    </div>
                    <span className={styles.vehicleName}>{vehicle.name}</span>
                </div>
            </TableCell>
            <TableCell>
                <p>{vehicle.maxPets}</p>
            </TableCell>
            <TableCell isActions>
                <ThreeDotsDropdown
                    options={dropdownOptions}
                    direction={isLast ? 'up' : 'down'}
                />
            </TableCell>
        </TableRow>
    );
};

export default VehicleRow;
